<template>
<ButtonSecondary v-on="$listeners" class="v-btn--delete">
  <template v-slot:icon>
    <DeleteIcon/>
  </template>
  <template v-slot:text>
    {{$t('buttons.delete')}}
  </template>
</ButtonSecondary>
</template>

<script>
import ButtonSecondary from "./templates/ButtonSecondary";
import DeleteIcon from "../icons/DeleteIcon";
export default {
  name: "ButtonSecondaryAction",
  components: {DeleteIcon, ButtonSecondary}
}
</script>

<style scoped lang="scss">
</style>

<!-- The following style have to be declared as global styles, otherwise they have no effect. -->
<style lang="scss">
.v-btn--delete {
  svg {
    .a {
      stroke: map-get($green, 'base');
    }
  }

  &:hover {
    svg {
      .a {
        stroke: $white;
      }
    }
  }
}
</style>
